import axios from "axios";

import { userLogout } from "./user";
import { getAuthHeader } from "../headers";

// ===================================
// GET PAST REVIEWS FOR REVIEWER
// ===================================
export const pastReviewsLoading = () => {
	return {
		type: "PAST_REVIEWS_LOADING"
	};
};

export const pastReviewsError = err => {
	return {
		type: "PAST_REVIEWS_ERROR",
		err
	};
};

export const pastReviewsSuccess = data => {
	return {
		type: "PAST_REVIEWS_SUCCESS",
		data
	};
};

// Get past reviews for a reviewer from backend route
export function getPastReviews(reviewerId){
    return (dispatch, getState) => {
        dispatch(pastReviewsLoading());

        return axios
            .get(process.env.REACT_APP_API_URL + "reviewer/past-reviews?id=" + reviewerId , {
                headers: getAuthHeader(getState().user, true)
            })
            .then(response => {
                if (response.data.status === 403) {
					dispatch(userLogout("reviewer"));
					return Promise.resolve(response);
				} else if (response.data.status && response.data.status !== 200) {
					dispatch(pastReviewsError(response.data.errors));
					return Promise.resolve(response);
				} else {
					dispatch(pastReviewsSuccess(response.data));
					return Promise.resolve(response);
				}
            })
            .catch(err => {
				dispatch(pastReviewsError({ general: err }));
			});
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/pastReviews.js